import { render, staticRenderFns } from "./SchoolEdit.vue?vue&type=template&id=23a4ba0c&scoped=true"
import script from "./SchoolEdit.vue?vue&type=script&lang=js"
export * from "./SchoolEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a4ba0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23a4ba0c')) {
      api.createRecord('23a4ba0c', component.options)
    } else {
      api.reload('23a4ba0c', component.options)
    }
    module.hot.accept("./SchoolEdit.vue?vue&type=template&id=23a4ba0c&scoped=true", function () {
      api.rerender('23a4ba0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolManage/schools/SchoolEdit.vue"
export default component.exports